import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const backendApp = process.env.REACT_APP_BACKEND_URL;

const Review = ({ threadId, setIsEndConversation }) => {
  const [reviewText, setReviewText] = useState("");
  const [rating, setRating] = useState(0);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [hoverRating, setHoverRating] = useState(0);
  const navigate = useNavigate();

  const back =  () => {
    setIsEndConversation(false);
    // navigate('/')
    // window.parent.postMessage({ action: "closeIframe" }, "*");
  };
  const closeConversation = () => {
    setIsEndConversation(false);
    navigate('/')
    window.parent.postMessage({ action: "closeIframe" }, "*");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setError("")
    if (!rating) {
      setError("Please rate the conversation");
      return;
    }
    // if (!reviewText) {
    //   setError("Please write a review");
    //   return;
    // }
    setError("");
    if (rating) {
      setLoading(true);
      axios
        .post(`${backendApp}/review`, { threadId, rating, review: reviewText || null })
        .then((res) => {
          setLoading(false);
          setReviewText("");
          setRating(0);
          setSuccess(true);
        })
        .catch((err) => {
          setLoading(false);
          setError("Something went wrong");
        });
    }
  };

  return (
    <div style={{width: '80%', minWidth: "300px", margin: "0 auto", padding: "20px" }}>
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Leave a Review</h2>
      {success && (
        <>
        <br/>
        <p style={{ color: "#87b048", textAlign: "center" }}>
            Thank you for your feedback!
          </p>
        </>
      )}
      {success && (
        <button
          onClick={closeConversation}
          style={{
            marginTop: "20px",
            padding: "10px 20px",
            backgroundColor: "#87b048",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            width: "100%",
          }}
        >
          Close
        </button>
      )}
      {!success && (
        <form onSubmit={handleSubmit}>
          {/* Star Rating Input */}

          {/* <div style={{ textAlign: "center", marginTop: "20px" }}>
            
            <p>Was this answer helpful?</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <button
                type="button"
                onClick={() => setHelpful(true)}
                style={{
                  padding: "10px 20px",
                  backgroundColor: helpful === true ? "#87b048" : "#ccc",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Yes
              </button>
              <button
                type="button"
                onClick={() => setHelpful(false)}
                style={{
                  padding: "10px 20px",
                  backgroundColor: helpful === false ? "#87b048" : "#ccc",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                No
              </button>
            </div>
          </div> */}
          <div>
            <div
              style={{
                display: "flex",
                gap: "5px",
                fontSize: "24px",
                cursor: "pointer",
                justifyContent: "center",
              }}
            >
              {[1, 2, 3, 4, 5].map((value) => (
                <span
                  key={value}
                  onClick={() => setRating(value)}
                  onMouseEnter={() => setHoverRating(value)} // Update hoverRating on hover
            onMouseLeave={() => setHoverRating(0)} 
                  style={{
                    color: value <= (hoverRating || rating) ? "#FFD700" : "#ccc", // Highlight stars up to the selected rating
                  }}
                >
                  ★
                </span>
              ))}
            </div>
          </div>

          {/* Review Text Input */}
          <div style={{ marginTop: "20px" }}>
            <label
              htmlFor="reviewText"
              style={{ display: "block", marginBottom: "8px" }}
            >
              Your Review:
            </label>
            <textarea
              id="reviewText"
              value={reviewText}
              onChange={(e) => setReviewText(e.target.value)}
              rows="4"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                resize: "none",
              }}
              placeholder="Write your review here..."
            ></textarea>
          </div>

          {/* Submit Button */}
          {error && (
            <p style={{ 
              color: "red", 
              textAlign: "center",
              wordWrap: "break-word",
              whiteSpace: "pre-wrap",
              maxWidth: "400px"
            }}>{error}</p>
          )}
          <button
            type="submit"
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              backgroundColor: loading ? "#ccc" : "#87b048",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              width: "100%",
            }}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
          <button
            onClick={back}
            style={{
              marginTop: "20px",
              padding: "10px 20px",
              backgroundColor: "#87b048",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              width: "100%",
            }}
          >
            Back
          </button>
        </form>
      )}
    </div>
  );
};

export default Review;
